var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V16H4V20H20V16H22ZM13 12.5858L16.2929 9.29289L17.7071 10.7071L12 16.4142L6.29289 10.7071L7.70711 9.29289L11 12.5858V2H13V12.5858Z",
    fill: "#657483"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/PrintIcon.87ab23066d3b91908a435560462675ce.svg";
export { ForwardRef as ReactComponent };